import { dealInfoHelpers } from 'widget/player-widget';
import commonTranslations from 'shared/translations/overlay-common-translations';
import formatMessageWithDealInfo from './_format-message-with-deal-info';
import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';


export const DEFAULT_TRANSLATIONS = {
  [FULL_ACCESS_ACTION_NAMES.BUY]: commonTranslations.buy,
  [FULL_ACCESS_ACTION_NAMES.RENT]: commonTranslations.rent,
  [FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT]: commonTranslations.buyFrom,
};

const PURCHASE_ACTION_NAMES = _.keys(DEFAULT_TRANSLATIONS);

/**
 * Is purchase video button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export function isVisible({ channel, video }) {
  return _.includes(PURCHASE_ACTION_NAMES, getFullAccessActionName(channel, video));
}

/**
 * Purchase video button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translations {Object} see DEFAULT_TRANSLATIONS
 * @return {React.Component}
 */
export default function renderPurchaseButtonText({ channel, video, translations = DEFAULT_TRANSLATIONS }) {
  switch (getFullAccessActionName(channel, video)) {
    case FULL_ACCESS_ACTION_NAMES.BUY:
      return formatMessageWithDealInfo(
        translations[FULL_ACCESS_ACTION_NAMES.BUY],
        dealInfoHelpers.getSalePriceInfo(video.dealInfo)
      );
    case FULL_ACCESS_ACTION_NAMES.RENT:
      return formatMessageWithDealInfo(
        translations[FULL_ACCESS_ACTION_NAMES.RENT],
        dealInfoHelpers.getRentPriceInfo(video.dealInfo)
      );
    case FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT:
      return formatMessageWithDealInfo(
        translations[FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT],
        dealInfoHelpers.getMinPriceInfo(video.dealInfo)
      );
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/purchase-button-text.js